<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
          <div class="card-toolbar">
            <ButtonDropdownFilter
                    :btn-title="$t('pipelines.label.prospect')"
                    :options="contacts"
                    value-field="id"
                    name-field="fullname"
                    v-model="query.contact_id"
                    :border="true"
                />
          </div>   
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-if="getInvoiceAndAdvanceCountStatistics.total_invoices == 0" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-if="getInvoiceAndAdvanceCountStatistics.total_invoices > 0" class="p-5">
              <div class="row">
                <div class="col-12 col-md-7 col-lg-7 mb-5">
                  <div class="row position-relative">
                    <canvas id="kt_chartjs_moyen_invoices" class="mh-400px"></canvas>
                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; height: 50%; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                      <div class="text-center">
                        <h1 class="display-2">{{getInvoiceAndAdvanceCountStatistics.total_invoices}}</h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center">
                  <div class="p-5" style="border: 2px solid #CCCFD3; border-radius: 8px; width: 100%;">
                    <div class="d-flex mb-15">
                      <span class="bg-primary px-20 py-5 me-2" style="border-radius: 5px;"></span>
                      <span class="mt-2">{{ $t('invoices.total_invoice') }}: <span class="fw-bold">{{getInvoiceAndAdvanceCountStatistics.total_invoices}}</span></span>
                    </div>
                    <div class="d-flex mb-5">
                      <span class="px-20 py-5 me-2" style="border-radius: 5px; background-color: #0072CE66;"></span>
                      <span class="mt-2">{{ $t('invoices.advance_invoice_total') }}: <span class="fw-bold">{{getInvoiceAndAdvanceCountStatistics.total_advances}}</span></span>
                    </div>
                    <div class="row text-start fw-bold fs-3">
                      <div v-html="formattedInvoicePercent"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import {  shallowRef,onMounted, ref} from 'vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import Loader from '@/components/Loader.vue';
import { watch } from 'vue';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    contact_id: '',
    payment_type_id: ""
})

const getInvoiceAndAdvanceCountStatistics = ref([])
const chartPipelineRef = shallowRef(null)

const contacts = computed(() => store.getters['contacts/getContacts'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  if(isSafe(query.value.start_date) && isSafe(query.value.end_date)){
     Promise.all([
       props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, contact_id: query.value.contact_id, payment_type_id: query.value.payment_type_id}).then((res) => {

          getInvoiceAndAdvanceCountStatistics.value = res?.data?.getInvoiceAndAdvanceCountStatistics || res?.response?.data;

        }),  
        store.dispatch('contacts/loadContacts'),

    ]).then(() => {
      chartPipeline()
    }) 
  }
    
}


function chartPipeline(){
  let names = [];
  let counts = [];
  let colors = [];

  if(getInvoiceAndAdvanceCountStatistics.value.total_advances > 0){
    names.push(i18n.global.t('invoices.advance_invoice_total'))
    counts.push(getInvoiceAndAdvanceCountStatistics.value.total_advances)
    colors.push('#0072CE66')
  }
  if(getInvoiceAndAdvanceCountStatistics.value.total_invoices > 0){
    names.push(i18n.global.t('invoices.total_invoice'))
    counts.push(getInvoiceAndAdvanceCountStatistics.value.total_invoices)
    colors.push('#0072CE')
  }

  if(names.length === 0 || counts.length === 0 || colors.length === 0){
    getInvoiceAndAdvanceCountStatistics.value = [];
  }

  let ctx = document.getElementById('kt_chartjs_moyen_invoices');

  if (ctx) {
    if(Chart.getChart("kt_chartjs_moyen_invoices")) {
      Chart.getChart("kt_chartjs_moyen_invoices")?.destroy()
    }
    let context = ctx.getContext('2d');
    let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');

    let data = {
        labels: names,
        datasets: [{
          data: counts,
          backgroundColor: colors,
          hoverOffset: 10
      }]
    };

    let config = {
        type: 'doughnut',
        data: data,
        options: {
          plugins: {
              legend: {
                  display: true,
                  position: 'bottom'
              },
              tooltip: {
                  callbacks: {
                      label: function(context) {
                        let countLabel = i18n.global.t('invoices.count');
                          return `${countLabel}: ${$formatLocalAmount(context.parsed)}`;
                      }
                  }
              },
              centerText: {
                display: true,
                text: '15'
              }
          },
          responsive: true,
          elements: {
            arc: {
                borderWidth: 1 
            }
          },
          cutout: '80%'
        },
        defaults:{
            global: {
                defaultFont: fontFamily
            }
        }
    };

    if (!chartPipelineRef.value) {
      chartPipelineRef.value = new Chart(ctx, config);
    }else{
      chartPipelineRef.value.destroy()
      chartPipelineRef.value = new Chart(ctx, config);
    }
  } else {
    console.error('Canvas element not found');
  }
}


const formattedInvoicePercent = computed(() => {
    return i18n.global.t('invoices.invoice_validate_percent', { percent: getInvoiceAndAdvanceCountStatistics.value.percentage_with_advance+'%' });
});
  
onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

function isSafe(date){
  if(!date || date === undefined )
    return false

  return true
}
</script>